import {IFaqQuestion} from "./IFaqItem";
import {useState} from "react";
import AnimateHeight from "react-animate-height";
import arrowDown from '../../../imgs/arrow_down.png'

interface IFaqQuestionProps {
    question: IFaqQuestion
    mobile: boolean
}

export default function FaqQuestion(props: IFaqQuestionProps) {
    const [state, setState] = useState(false);

    function navigate(e: any) {
        if (e.target.tagName === "A" || e.target.tagName === "a") {
            const href = e.target.getAttribute('href');
            if (!href.startsWith('https://')) {
                e.preventDefault();
                window.document
                    .querySelector(`#${href}`)
                    ?.scrollIntoView({behavior: "smooth", block: "start"})
            }
        }
    }

    if (props.mobile) {
        return <div className="Faq_item_section_question">
            <a className="Faq_item_section_question_container_mobile"
               onClick={(e) => {
                   setState(!state)
               }}>
                <div className="Faq_item_section_question_container_question_mobile">
                    {props.question.question}
                    <img
                        style={{animationName: state ? "rotate-forwards" : "rotate-backwards"}}
                        className={`Faq_item_section_question_container_question_mobile_icon Faq_item_section_question_container_question_mobile_icon_rotate`}
                        src={arrowDown}/>
                </div>
                <div className="Faq_item_section_question_container_separator"/>
            </a>
            <AnimateHeight height={state ? "auto" : 0} animateOpacity={true}>
                <div onClick={(e) => navigate(e)} dangerouslySetInnerHTML={{__html: props.question.answer}}
                     className="Faq_item_section_question_container_answer"/>
            </AnimateHeight>
        </div>
    } else {
        return <div className="Faq_item_section_question">
            <a className="Faq_item_section_question_container"
               onClick={(e) => {
                   setState(!state)
               }}>
                <div className="Faq_item_section_question_container_question">
                    {props.question.question}
                    <img
                        style={{animationName: state ? "rotate-forwards" : "rotate-backwards"}}
                        className={`Faq_item_section_question_container_question_mobile_icon Faq_item_section_question_container_question_mobile_icon_rotate`}
                        src={arrowDown}/>
                </div>
                <div className="Faq_item_section_question_container_separator"/>
            </a>
            <AnimateHeight height={state ? "auto" : 0} animateOpacity={true}>
                <div onClick={(e) => navigate(e)} dangerouslySetInnerHTML={{__html: props.question.answer}}
                     className="Faq_item_section_question_container_answer"/>
            </AnimateHeight>
        </div>
    }
}